//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import inputbox from '@/components/ui/inputbox';

export default {
    components: {navbar,inputbox},
    data(){
        return {
            info: {
                phone: '',
                code: '',
                token: '',
            },
            sms: {
                timeOrigin: 60,
                time: 60,
                text: '获取验证码',
                disabled: false,
                handle: null,
            },
            showPage: false,
        }
    },
    methods:{

        // 绑定
        bindWx(){

            const info = this.info;

            if(!common.isMobile(info.phone)){
                this.$vux.toast.text("输入手机号不正确");
                return;
            }

            if(info.code.length < 4){
                this.$vux.toast.text("验证码不正确");
                return;
            }

            const opts = {
                url: api.loginWxBindMobile,
                data: {
                    ...info,
                },
                type: 'post',
            }
            common.query(opts).then(res=>{
                common.storage("userInfo",JSON.stringify(res.data));
                const callback = common.storage("callback") || "/member";

                common.storage("callback",'');
                common.storage("referid",'');

                this.$router.push(callback);
            },res=>{
                this.$vux.toast.text(res.message)
            });

        },

        // 查询是否绑定手机号
        wxLogin(){
            const opts = {
                url: api.loginWxInfo,
                data: {
                    ...this.info
                },
                type: 'get',
            }
            common.query(opts).then(res=>{
                if(res.data.phone_mob){
                    common.storage("userInfo",JSON.stringify(res.data));
                    const callback = common.storage("callback") || "/member";

                    common.storage("callback",'');
                    common.storage("referid",'');

                    this.$router.push(callback);
                }else{
                    this.showPage = true;
                }
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 发送登录短信
        sendSms(){

            if(this.sms.disabled){
                return;
            }

            if(!common.isMobile(this.info.phone)){
                this.$vux.toast.text("输入手机号不正确");
                return;
            }

            this.sms.disabled = true;

            const opts = {
                url: api.loginSendSms,
                data: {
                    ...this.info
                },
                type: 'post'
            }

            common.query(opts).then(res=>{
                this.smsTimeout();
            },res=>{
                this.$vue.toast.show(res.message);
                this.sms.disabled = false;
            })

        },

        // 验证码倒计时
        smsTimeout(){
            this.sms.time--;
            this.sms.text = this.sms.time + ' 秒后获取';

            clearTimeout(this.sms.handle);
            this.sms.handle = setTimeout(()=>{
                if(this.sms.time === 0){
                    this.sms.text = "获取验证码";
                    this.sms.time = this.sms.timeOrigin;
                    this.sms.disabled = false;
                }else{
                    this.smsTimeout();
                }
            },1000);
        },

    },
    mounted(){
        this.info.token = this.$route.query.token || '';
        this.wxLogin();
    },
}




// WEBPACK FOOTER //
// ./src/views/login/loginWx.vue